import { FC } from "react";

import { BentoElement, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

import TiledImageVertical from "./TiledImageVertical";
import TiledText from "./TiledText";

const TiledBlockVWithImage: FC<{ items: BentoElement[] }> = ({ items }) => {
  let texts: BentoTextElement[] = [];
  let image;
  items.forEach((item, index) => {
    if (item.type === BentoElementType.image) {
      image = item as EditorialModuleImage;
    } else if ((item.type = BentoElementType.text)) {
      texts.push(item as BentoTextElement);
    }
  });
  if (image && texts.length === 2 && items[0].type === BentoElementType.image) {
    return (
      <div className="grid grid-cols-2 gap-xs">
        <TiledImageVertical entry={image}></TiledImageVertical>
        <div className="col-span-1 grid grid-cols-1 gap-xs">
          {texts.map((text, index) => (
            <>
              <TiledText slideIndex={index + 1} key={`title-blocktext-${index + 1}`} entry={text} />
            </>
          ))}
        </div>
      </div>
    );
  } else if (image && texts.length === 2 && items[0].type === BentoElementType.text) {
    return (
      <div className="grid grid-cols-2 gap-xs">
        <div className="col-span-1 grid grid-cols-1 gap-xs">
          {texts.map((text, index) => (
            <>
              <TiledText slideIndex={index + 1} key={`title-blocktext-${index + 1}`} entry={text} />
            </>
          ))}
        </div>
        <TiledImageVertical entry={image}></TiledImageVertical>
      </div>
    );
  }
};
export default TiledBlockVWithImage;
